import styled from 'styled-components';

const PageTitle = styled.span`
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.1em;
  vertical-align: middle;
  text-transform: uppercase;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export {
  PageTitle
};



// WEBPACK FOOTER //
// ./src/app/admin/components/Typography/index.js